// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1VrjS","box":"WorkspacesBox_box__zGo2n","node":"WorkspacesBox_node__3McoZ"};